import Vue from 'vue';

import moment from 'moment-timezone';
moment.locale('es');

Vue.filter('dateMinutHuman', function (value) {
	if (value) {
		return moment(value).format('DD/MMM/YYYY hh:mm A');
	} else {
		return 'Sin Fecha';
	}
});

Vue.filter('dateHuman', function (value) {
	if (value) {
		return moment(value).format('DD/MMM/YYYY');
	} else {
		return 'Sin Fecha';
	}
});



Vue.filter('datetime', function (value) {
	if (value) {
		return moment(value).tz("America/Mexico_City").format('dddd, LL hh:mm A').toLocaleUpperCase();
	} else {
		return 'NO DISPONIBLE';
	}

});

Vue.filter('datetimeSimple', function (value) {
	if (value) {
		return moment(value).tz("America/Mexico_City").format('DD/MM/YYYY hh:mm A').toLocaleUpperCase();
	} else {
		return 'NO DISPONIBLE';
	}
});

Vue.filter('dateMix', function (value) {
	if (value) {
		return moment(value).tz("America/Mexico_City").format('DD/MMM/YYYY').toLocaleUpperCase().replace('.', '');
	} else {
		return 'NO DISPONIBLE';
	}
});

Vue.filter('date', function (value) {
	if (value) {
		return moment.tz(value, "YYYY-MM-DD", "America/Mexico_City")
			.format('dddd, LL').toLocaleUpperCase();
	} else {
		return 'NO DISPONIBLE';
	}
});

Vue.filter('dateSQL', function (value) {
	if (value) {
		return moment(value).tz("America/Mexico_City").format('YYYY-MM-DD');
	} else {
		return 'NO DISPONIBLE';
	}
});

Vue.filter('dateSimple', function (value) {
	if (value) {
		return moment(value).tz("America/Mexico_City").format('DD/MM/YYYY');
	} else {
		return 'NO DISPONIBLE';
	}
});


Vue.filter('Money', function (value) {
	const numericValue = parseFloat(value);
	if (!isNaN(numericValue)) {
		return numericValue.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
	} else {
		return '0.00';
	}
});


Vue.filter('formatSize', function (size) {
	const numericSize = parseFloat(size);
	if (!isNaN(numericSize) && numericSize > 0) {
		if (numericSize > 1024 * 1024 * 1024 * 1024) {
			return (numericSize / 1024 / 1024 / 1024 / 1024).toFixed(2) + ' TB'
		} else if (numericSize > 1024 * 1024 * 1024) {
			return (numericSize / 1024 / 1024 / 1024).toFixed(2) + ' GB'
		} else if (numericSize > 1024 * 1024) {
			return (numericSize / 1024 / 1024).toFixed(2) + ' MB'
		} else if (numericSize > 1024) {
			return (numericSize / 1024).toFixed(2) + ' KB'
		}
		return numericSize.toString() + ' B'
	} else {
		return '0 B';
	}
});


